import { render, staticRenderFns } from "./saledaily.vue?vue&type=template&id=05bd64f1&scoped=true&"
import script from "./saledaily.vue?vue&type=script&lang=js&"
export * from "./saledaily.vue?vue&type=script&lang=js&"
import style0 from "./saledaily.vue?vue&type=style&index=0&id=05bd64f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bd64f1",
  null
  
)

export default component.exports